import { Button, Input, Space, Table, Modal, message, Tag, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";
import { ExclamationCircleFilled } from '@ant-design/icons';
import ComparisonProductNoticeEdit from "./ComparisonProductNoticeEdit";
import EUtils, { IButtonConfig } from "../../../utils/EUtils";
import ESearch, { IMoreConfig, ISearchConfig } from "../../../components/esearch/ESearch";

const { confirm } = Modal;

const ComparisonProductNotice = () => {
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState<any>({ pageIndex: 1, pageSize: 50 });
    const [searchValue, setSearchValue] = useState('');
    const [dataSource, setDataSource] = useState<any>([]);
    const [isOpen, setIsOpen] = useState(false);
    const [editRecord, setEditRecord] = useState<any>({});

    const [scrollY, setScrollY] = useState("");
    const resize = () => setScrollY(EUtils.getTableScroll(82, ''));
    //页面加载完成后才能获取到对应的元素及其位置
    useEffect(() => {
        resize();
    }, [dataSource])

    useEffect(() => {
        loadData();
    }, [page])

    const loadData = () => {
        var params = {
            ...page,
            options: refESearch.current?.getOptions()
        };
        Server.Post(URL.ComparisonProductNotice.GetComparisonProductNoticeList, params).then((response: any) => {
            if (response.isSuccess) {
                setDataSource(response.data);
                setTotal(response.total);
            }
        })
    }

    const showDeleteConfirm = (record: any) => {
        confirm({
            title: '删除产品公告',
            icon: <ExclamationCircleFilled />,
            content: '产品公告标题[' + record.title + ']，确认要删除，一旦删除将不能恢复，请慎重操作',
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var param = { comparisonProductNoticeID: record.comparisonProductNoticeID }
                Server.Post(URL.ComparisonProductNotice.DeleteComparisonProductNotice, param).then((response: any) => {
                    if (response.isSuccess) {
                        loadData();
                        message.success('删除成功!');
                    }
                })
            },
            onCancel() {
            },
        });
    };

    const columns: any[] = [{
        key: 'title', title: '标题', dataIndex: 'title', fixed: 'left', ellipsis: true, width: 180,
        render: (text: any, record: any) => <a onClick={() => {
            setEditRecord({
                viewMode: 1,
                comparisonProductNoticeID: record.comparisonProductNoticeID
            });
            setIsOpen(true)
        }}>{text}</a>
    },
    {
        title: '上线状态', dataIndex: 'isOnline', ellipsis: true, width: 80,
        render: (text: any) => {
            return text ? <Tag color="green">上线</Tag> : <Tag color="red">下线</Tag>
        }
    },
    { title: '内容', dataIndex: 'content', ellipsis: true, width: 480 },
    {
        title: '操作', align: 'center', width: 80, fixed: 'right', ellipsis: true,
        render(value: any, record: any, index: any) {
            var configs: IButtonConfig[] = [
                {
                    name: '编辑', onClick: () => {
                        setEditRecord({
                            viewMode: 1,
                            comparisonProductNoticeID: record.comparisonProductNoticeID
                        });
                        setIsOpen(true)
                    }
                },
                { name: '删除', onClick: () => { showDeleteConfirm(record); }, danger: true },
                { name: '上线', onClick: () => { showOnlineConfirm(record); }, hidden: record.isOnline },
                { name: '下线', onClick: () => { showOnlineConfirm(record); }, hidden: !record.isOnline, danger: true },
            ];
            return EUtils.InitButtons(configs);
        }
    }];
    const showOnlineConfirm = (record: any) => {
        confirm({
            title: record.isOnline ? '下线产品公告' : '上线产品公告',
            icon: <ExclamationCircleFilled />,
            content: '产品公告[' + record.title + ']，确认要' + (record.isOnline ? '下线' : '上线'),
            okText: '确定',
            cancelText: '取消',
            onOk() {
                var param = {
                    comparisonProductNoticeID: record.comparisonProductNoticeID,
                    isOnline: !record.isOnline
                }
                Server.Post(URL.ComparisonProductNotice.SetOnlineComparisonProductNotice, param).then((response: any) => {
                    if (response.isSuccess) {
                        message.success((record.isOnline ? '下线' : '上线') + '成功!');
                        loadData();
                    } else {
                        message.warn(response.returnMsg);
                    }
                })
            },
            onCancel() {
            },
        });
    };

    const refESearch = useRef<any>(null);
    const searchConfig: ISearchConfig[] = [
        { filedID: 'Title', filedName: '标题' },
        { filedID: 'Content', filedName: '内容' },
    ];
    const moreConfig: IMoreConfig[] = [
        { type: 'select', filedID: 'IsOnline', title: '上线状态', data: [{ value: false, label: '下线' }, { value: true, label: '上线' }] },
    ];

    return <div>
        <ESearch searchConfig={searchConfig} moreConfig={moreConfig} onLoad={loadData} resize={resize} ref={refESearch} />
        <div>
            <div style={{ backgroundColor: '#fafafa', border: '1px solid #e7e7eb', borderBottom: 'none', height: '45px', padding: '5px' }}>
                <span style={{ lineHeight: '30px', margin: '5px', fontWeight: 'bold' }}></span>
                <Space style={{ float: 'right' }}>
                    <Button type="primary" onClick={() => {
                        setEditRecord({
                            viewMode: 0,
                            comparisonProductNoticeID: null
                        });
                        setIsOpen(true)
                    }}>新增</Button>
                </Space>
            </div>
            <Table size="small"
                bordered
                scroll={dataSource.length > 0 ? { x: 'max-content', y: scrollY } : { x: 'max-content' }}
                columns={columns} dataSource={dataSource} pagination={{
                    position: ['bottomRight'],
                    style: { margin: '5px' },
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: total,
                    showTotal: ((total) => {
                        return "共" + total + "条";
                    }),
                    current: page.pageIndex,
                    defaultCurrent: 20,
                    pageSize: page.pageSize,
                    pageSizeOptions: [10, 20, 50, 100, 200],
                    onShowSizeChange: ((page, pageSize) => {
                        setPage({
                            pageIndex: page,
                            pageSize: pageSize
                        });
                    }),
                    onChange: ((page, pageSize) => {
                        setPage({
                            pageIndex: page,
                            pageSize: pageSize
                        });
                    })
                }}
                summary={(pageData) => {
                    return <Table.Summary fixed>
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={1} >
                                <Typography.Text>合计:{dataSource.length}</Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={5} align={'center'}>
                                <Typography.Text></Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={2} align={'center'}></Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                }} />
        </div>
        <ComparisonProductNoticeEdit isOpen={isOpen} setIsOpen={() => setIsOpen(false)} loadData={loadData} {...editRecord} />
    </div>
}
export default ComparisonProductNotice;